import React, { useEffect, Suspense, lazy } from "react";
import MainLayout from "../layouts/MainLayout";
import { Helmet } from "react-helmet-async"; // SEO

// Lazy loaded components
const LazyHero = lazy(() => import("../components/Hero"));
const LazyAbout = lazy(() => import("../components/About"));
const LazyExperience = lazy(() => import("../components/Experience"));
const LazySkillAndTools = lazy(() => import("../components/SkillAndTools"));
const LazyEducation = lazy(() => import("../components/Education"));
const LazyAchievementCard = lazy(() => import("../components/Achievements"));
const LazyPortfolio = lazy(() => import("../components/Portfolio"));
const LazyContactUs = lazy(() => import("../components/ContactUs"));
const LazyScrollToTop = lazy(() => import("../components/ScrollToTop"));

function Home() {
  useEffect(() => {
    const toTopButton = document.getElementById("to-top-button");

    // Function to toggle button visibility based on scroll position
    const handleScroll = () => {
      if (window.scrollY > 500) {
        toTopButton.classList.remove("hidden");
      } else {
        toTopButton.classList.add("hidden");
      }
    };

    // Attach scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Muhammad Taha | Software Engineer 💻</title>
        {/* Meta description for search engines */}
        <meta
          name="description"
          content="I am a Software Engineer with expertise in the MERN stack. Skilled in MongoDB, Express, React, Node.js, JavaScript, TypeScript. I build web applications with a focus on performance and user experience."
        />

        {/* Open Graph meta tags for social media sharing  */}
        <meta property="og:type" content="profile" />
        <meta
          property="og:title"
          content="Software Engineer | MERN Stack Developer | JavaScript"
        />
        <meta
          property="og:description"
          content="I am a software Engineer specializing in building full-stack web applications using MongoDB, Expressjs, Reactjs, Node.js, JavaScript, TypeScript. Check out my portfolio to see my latest projects!"
        />
        <meta property="og:image" content="/src/assets/profile.webp" />
        <meta
          property="og:url"
          content="https://muhammadtaha-portfolio.vercel.app/"
        />
      </Helmet>

      <MainLayout>
        {/* Wrap lazy-loaded components in Suspense with a fallback */}
        <Suspense fallback={<div>Loading...</div>}>
          <LazyHero />
          <LazyAbout />
          <LazyExperience />
          <LazySkillAndTools />
          <LazyEducation />
          <LazyAchievementCard />
          <LazyPortfolio />
          <LazyContactUs />
          <LazyScrollToTop />
        </Suspense>
      </MainLayout>
    </>
  );
}

export default Home;
